import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Parser from 'react-html-parser';
import './TextWithReadMore.scss';
const TextWithReadMore = ({
  shortText,
  longText,
  textClass = '',
  useLong = false,
}) => {
  const [text, setText] = useState('');
  const short = `${String(shortText).substring(0, 800)}...`;
  const long = longText;

  useEffect(() => {
    if (useLong) {
      setText(long);
    } else {
      setText(short);
    }
  }, [short, long, useLong]);

  const toggleText = () => {
    if (text === short) {
      setText(long);
    } else {
      setText(short);
    }
  };

  return (
    <p className={`read__more__text ${textClass}`}>
      {Parser(text)}
      {long !== short.substring(short.length - 3, 3) && (
        <>
          <br />
          <span className='read__more__text__btn' onClick={() => toggleText()}>
            {text === short ? 'Read More' : ''}
          </span>
        </>
      )}
    </p>
  );
};

TextWithReadMore.propTypes = {
  shortText: PropTypes.string,
  longText: PropTypes.string.isRequired,
  textClass: PropTypes.string,
  useLong: PropTypes.bool,
};

export default TextWithReadMore;
